// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jkqh","top":"styles_top__1uxNM"};